import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import Link from '../../components/shared/Link';
import Search from '../../components/shared/Search4Field';
import Pagination from '../../components/shared/Pagination';
import PatientList from '../../components/patient/PatientList';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
} from '../../constants/RoleConstants';
import AddPatientButton from '../../components/shared/AddPatientButton';

const link = {
  textDecoration: 'none',
  color: 'inherit',
};

export class PatientListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        query: '',
        page: 0,
      },
      isFirstPage: true,
    };

    this.onClickClear = this.onClickClear.bind(this);
    this.onClickPage = this.onClickPage.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
  }

  componentDidMount = () => {
    this.getPatientList();
  }

  onClickClear() {
    this.setState({
      filter: Object.assign(this.state.filter, { query: '', page: 0 }),
      isFirstPage: true,
    });
    this.getPatientList(this.state.filter);
  }

  onClickSearch(query) {
    let filters = {};
    if (query.length !== 0) {
      filters = { filter: query };
    }
    this.setState({ filter: Object.assign(this.state.filter, { query }) });
    this.getPatientList(filters);
  }

  onClickPage(page) {
    this.setState({
      filter: Object.assign(this.state.filter, { page }),
      isFirstPage: false,
    });
    this.getPatientList(this.state.filter);
  }

  getPatientList = async (filter) => {
    const {
      actions: {
        fetchPatientList,
        createDangerAlert,
      },
    } = this.props;
    const result = await fetchPatientList(filter);
    if (result !== true) {
      createDangerAlert(result.message);
    }
  }

  canCreatePatients() {
    return [DOCTOR_ID, ASSISTANT_ID, NURSE_ID].indexOf(this.props.user.profile.roleId) > -1;
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          {/* the search bar and pagination are not really working
            now since we don't have page information along
            with patient list, if you don't want to show them, just hide them */}
          <h1>
            {i18n.t('patientList')}
          </h1>
          <p className="lead">
            {i18n.t('choosePatientMsg')}
          </p>
          <hr />
          <div className="row">
            <Search
              onClickClear={this.onClickClear}
              onClickSearch={this.onClickSearch}
            />
            <div className="col-lg-7 right">
              <Pagination
                pageInfo={this.props.patient.pageInfo}
                isLoading={this.props.patient.isPatientListLoading}
                onClickPage={this.onClickPage}
                isFirstPage={this.state.isFirstPage}
              />
            </div>
          </div>
          <div>
            <PatientList
              patientData={this.props.patient.patientList}
              isLoading={this.props.patient.isPatientListLoading}
              router={this.props.router}
            />
            <br />
            {
              this.canCreatePatients() && (
                <Link
                  href="medical-records-create"
                  style={link}
                  router={this.props.router}
                >
                  <AddPatientButton />
                </Link>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

PatientListContainer.propTypes = {
  actions: PropTypes.shape({
    fetchPatientList: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    profile: PropTypes.object.isRequired,
  }).isRequired,
  patient: PropTypes.shape({
    pageInfo: PropTypes.object.isRequired,
    patientList: PropTypes.arrayOf(PropTypes.object).isRequired,
    isPatientListLoading: PropTypes.bool.isRequired,
  }).isRequired,
  router: PropTypes.object.isRequired,
};

export default connectActionsAndReducers(PatientListContainer);



// WEBPACK FOOTER //
// ./src/containers/patient/PatientListContainer.js